import React, { useEffect, useContext, useState } from 'react';

import { LoginContext } from '../../hooks/context/LoginContext';

import Menusup from '../../componentes/menus/menusup/Menusup';
import Sidebar from '../../componentes/menus/sidebar/Sidebar';
import Formulario from '../../componentes/formulario/Formulario';
import FormRow from '../../componentes/formulario/FormRow';
import FormInput from '../../componentes/formulario/FormInput';
import Footer from '../../componentes/footer/Footer';
import Section from '../../componentes/ui/Section';
import MiDataTable from '../../componentes/ui/MiDataTable';
import { Alert } from '../../componentes/ui/Alert';
import MiSelect from '../../componentes/formulario/MiSelect';
import PermissionRefused from '../../componentes/ui/PermissionRefused';
import LoadingPage from '../../componentes/ui/LoadingPage';
import ListaRel from '../../componentes/formulario/ListaRel/ListaRel';

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Spinner from 'react-bootstrap/Spinner';

import useLogicForm from '../../hooks/useLogicForm';

import Cookies from 'universal-cookie';

import { Fragment } from 'react';

import { getTitle, getDecodedCookie } from '../../helpers/helperApp';

function TipGf(props){

    const cookies = new Cookies();

    // ***** Context *****
    const { validateSesion, socket, confApp, saveConfApp, getConfApp } = useContext(LoginContext);    

    // ***** State para la configuración de la pantalla *****
    const [ confPantalla, saveConfPantalla ] = useState(confApp)
    const [ loadedConf, saveLoadedConf ] = useState(false);
    const [ tieneNivel, saveTieneNivel ] = useState(true);
    const [ estadoFormPrin, saveEstadoFormPrin ] = useState("");
    const [ estadoFormHijo, saveEstadoFormHijo ] = useState("");


    // ***** Custom Hook - Lógica de los formularios *****
    const { registrosPrin, saveRegistrosPrin, formularioPrin, saveFormularioPrin, saveFormularioHijo , handleInputForm, handleLastReg, handleEditRegPrin, loadingTable, saveLoadingTable, loadReg, regIniciales, handleDeleteItemPrin, handleSubmitPrin, resetFormPrin, handleSelectFormPrin } = useLogicForm();

    useEffect( () => {        
        
        // ***** Validamos que el usuario esté logueado sino lo enviamos al login*****
        validateSesion(props)
            .then( (respuesta) => {
                if( confPantalla === undefined ){
                    return getConfApp();
                }else{                     
                    document.title = getTitle(confPantalla.config.trad, confPantalla.tipgf.title);                                       
                    if( respuesta == 1 ){
                        saveTieneNivel(true);
                        saveEstadoFormPrin(confPantalla.tipgf.padre.estadoform);
                        saveEstadoFormHijo(confPantalla.tipgf.hijo.estadoform);                            
                        // ***** Carga inicial de registros *****
                        if( registrosPrin ){
                            if( registrosPrin.length === 0 ){
                                saveLoadingTable(true);
                                regIniciales(saveRegistrosPrin, confPantalla.tipgf.padre.urls);
                                saveFormularioPrin(confPantalla.tipgf.padre.modelform);
                                saveFormularioHijo(confPantalla.tipgf.hijo.modelform);     
                            }
                        }  
                        // Seleccionar el id que nos llega como parámetro por la url
                        if( props.location.state ){
                            if( "idPrin" in props.location.state || "idHijo" in props.location.state ){
                                handleLastReg(props.location.state.idPrin, props.location.state.idHijo, confPantalla.tipgf.padre.urls, confPantalla.tipgf.hijo.urls, confPantalla.tipgf.padre.tabla, props.location.state.estadoFormPrin, saveEstadoFormPrin, saveEstadoFormHijo);     
                            }                        
                        }                      
                    }
                    else if( respuesta == 0 ){
                        saveTieneNivel(false);
                    }                    
                    saveLoadedConf(true);        
                }
            })
            .then( (respuesta) => {
                if( respuesta !== undefined  ){
                    saveConfPantalla(respuesta.msg);
                    saveConfApp(respuesta.msg);             
                }
            })          

        // Liberamos todos los registros al salir de la pantalla
        return () =>{
            if( socket != null ){
                socket.emit("salirPantalla", { "idusu": getDecodedCookie('id'), "tabla": "undefined" })
            }
                document.querySelector("body").classList.remove("sidebar-open");
        } 

    },[confPantalla])
 

    return(
        <div className="App wrapper">
            <div>
                {   loadReg ?
                    <div className="alertFullWhite">
                        <Spinner animation="border" />
                    </div> 
                    :
                    null
                }
                {
                    !loadReg ?
                        <Alert fondo={true} />
                    :
                        <Alert />
                }                                
            </div>    
        {
            confPantalla !== undefined
            ?
                <Fragment>
                    <Menusup 
                        props = { props }
                    />
                    <Sidebar 
                        props = { props }
                    />
                </Fragment>
            :
            null
        } 
        <div className="content-wrapper">
            <div className="content-header">
            </div>
            <section className="content">
                {
                    !tieneNivel 
                    ?
                        <PermissionRefused
                            traduction={confPantalla.config.trad.components.permissionrefused} 
                        />
                    :
                    <Fragment>
                    {
                        loadedConf === true && confPantalla !== undefined
                        ?
                        <Section titulo={ confPantalla.tipgf.section.titulo } icono={ confPantalla.tipgf.section.icono } col={ confPantalla.tipgf.section.col } idPrin={ formularioPrin.id } wiki={ confPantalla.tipgf.section.wiki } >
                            <Formulario 
                                        estadoForm= { estadoFormPrin }
                                        loading=    { loadReg ? true : false }
                                        btnNew={ confPantalla.tipgf.padre.btnform.new }
                                        btnSave={ confPantalla.tipgf.padre.btnform.save }
                                        btnSaveAndNew={ confPantalla.tipgf.padre.btnform.saveandnew }
                                        btnDelete={ confPantalla.tipgf.padre.btnform.delete }
                                        btnClone={ confPantalla.tipgf.padre.btnform.clone }
                                        handleSubmit = { e => handleSubmitPrin(e, confPantalla.tipgf.padre.urls, confPantalla.tipgf.padre.modelform, confPantalla.tipgf.padre.tabla, confPantalla.tipgf.hijo.modelform, confPantalla.tipgf.title) } 
                                        formulario = { formularioPrin } 
                                        resetForm = { e => resetFormPrin(confPantalla.tipgf.padre.modelform, true, confPantalla.tipgf.padre.tabla) } 
                                        handleDeleteItem = { e => handleDeleteItemPrin(undefined, confPantalla.tipgf.padre.urls, confPantalla.tipgf.padre.modelform, confPantalla.tipgf.padre.tabla, confPantalla.tipgf.title) } 
                            >         
                            <h4>{ formularioPrin.ruta }</h4> 
                            <Tabs defaultActiveKey="tab1" id="tab1">
                                <Tab eventKey="tab1" title={ confPantalla.tipgf.tabs.tab1.titulo }>
                                    <FormRow clases="" >
                                        <MiSelect  
                                            estadoForm=  { estadoFormPrin }
                                            val=         { formularioPrin.pad  }   
                                            loading=     { loadReg ? true : false }
                                            id=          { confPantalla.tipgf.padre.controles.pad.id }    
                                            name=        { confPantalla.tipgf.padre.controles.pad.name }   
                                            label=       { confPantalla.tipgf.padre.controles.pad.label }    
                                            placeholder= { confPantalla.tipgf.padre.controles.pad.placeholder }
                                            col=         { confPantalla.tipgf.padre.controles.pad.col } 
                                            isClearable= { confPantalla.tipgf.padre.controles.pad.isclearable }
                                            isSearchable={ confPantalla.tipgf.padre.controles.pad.issearchable }
                                            dataType=    { confPantalla.tipgf.padre.controles.pad.datatype }
                                            data=        { confPantalla.tipgf.padre.controles.pad.data }
                                            required=    { confPantalla.tipgf.padre.controles.pad.required } 
                                            disabled=    { confPantalla.tipgf.padre.controles.pad.disabled }
                                            readOnly =   { confPantalla.tipgf.padre.controles.pad.readonly }
                                            disablethisid={confPantalla.tipgf.padre.controles.pad.disablethisid}
                                            formulario = { formularioPrin } 
                                            change=      { handleSelectFormPrin }                                                    
                                        />                                    
                                        <FormInput                                                        
                                            estadoForm= { estadoFormPrin }
                                            value=      { formularioPrin.nom }
                                            loading=    { loadReg ? true : false }
                                            id=         { confPantalla.tipgf.padre.controles.nom.id }   
                                            type=       { confPantalla.tipgf.padre.controles.nom.type }  
                                            name=       { confPantalla.tipgf.padre.controles.nom.name }   
                                            label=      { confPantalla.tipgf.padre.controles.nom.label }                                                       
                                            placeholder={ confPantalla.tipgf.padre.controles.nom.placeholder }    
                                            col=        { confPantalla.tipgf.padre.controles.nom.col } 
                                            required=   { confPantalla.tipgf.padre.controles.nom.required }
                                            readonly=   { confPantalla.tipgf.padre.controles.nom.readonly }                                                
                                            disabled=   { confPantalla.tipgf.padre.controles.nom.disabled }
                                            change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                            onBlur=     {null} 
                                        /> 
                                        <FormInput                                                        
                                            estadoForm= { estadoFormPrin }
                                            value=      { formularioPrin.nom_en }
                                            loading=    { loadReg ? true : false }
                                            id=         { confPantalla.tipgf.padre.controles.nom_en.id }   
                                            type=       { confPantalla.tipgf.padre.controles.nom_en.type }  
                                            name=       { confPantalla.tipgf.padre.controles.nom_en.name }   
                                            label=      { confPantalla.tipgf.padre.controles.nom_en.label }                                                       
                                            placeholder={ confPantalla.tipgf.padre.controles.nom_en.placeholder }    
                                            col=        { confPantalla.tipgf.padre.controles.nom_en.col } 
                                            required=   { confPantalla.tipgf.padre.controles.nom_en.required }
                                            readonly=   { confPantalla.tipgf.padre.controles.nom_en.readonly }                                                
                                            disabled=   { confPantalla.tipgf.padre.controles.nom_en.disabled }
                                            change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                            onBlur=     {null} 
                                        /> 
                                    </FormRow>                                                       
                                </Tab>
                                <Tab eventKey="tab2" title={ confPantalla.tipgf.tabs.tab2.titulo }>
                                    <ListaRel
                                        estadoForm=  { estadoFormPrin }
                                        val=         { formularioPrin.rel_usu_gf  }   
                                        loading=     { loadReg ? true : false }
                                        id=          { confPantalla.tipgf.padre.controles.rel_usu_gf.select.id }    
                                        name=        { confPantalla.tipgf.padre.controles.rel_usu_gf.select.name }   
                                        label=       { confPantalla.tipgf.padre.controles.rel_usu_gf.select.label }    
                                        placeholder= { confPantalla.tipgf.padre.controles.rel_usu_gf.select.placeholder }
                                        col=         { confPantalla.tipgf.padre.controles.rel_usu_gf.select.col } 
                                        isClearable= { confPantalla.tipgf.padre.controles.rel_usu_gf.select.isclearable }
                                        isSearchable={ confPantalla.tipgf.padre.controles.rel_usu_gf.select.issearchable }
                                        dataType=    { confPantalla.tipgf.padre.controles.rel_usu_gf.select.datatype }
                                        data=        { confPantalla.tipgf.padre.controles.rel_usu_gf.select.data }
                                        required=    { confPantalla.tipgf.padre.controles.rel_usu_gf.select.required } 
                                        disabled=  { confPantalla.tipgf.padre.controles.rel_usu_gf.select.disabled }
                                        readOnly =   { confPantalla.tipgf.padre.controles.rel_usu_gf.select.readonly }
                                        disablethisid={ confPantalla.tipgf.padre.controles.rel_usu_gf.select.disablethisid }
                                        formulario = { formularioPrin }
                                        saveFormulario = { saveFormularioPrin }
                                        table = { confPantalla.tipgf.padre.controles.rel_usu_gf.table }
                                        traduction={confPantalla.config.trad.components.datatable}
                                    />  
                                </Tab>   
                            </Tabs>   
                            </Formulario>
                            <MiDataTable 
                                formulario={formularioPrin}
                                estadoForm= { estadoFormPrin }
                                id={"tipgf"}
                                columnas={confPantalla.tipgf.padre.datatable.columns}
                                data={registrosPrin}
                                buttons={confPantalla.tipgf.padre.datatable.buttons}
                                ordering={confPantalla.tipgf.padre.datatable.ordering}
                                order={confPantalla.tipgf.padre.datatable.order}
                                searching={confPantalla.tipgf.padre.datatable.searching}
                                paging={confPantalla.tipgf.padre.datatable.paging}
                                select={confPantalla.tipgf.padre.datatable.select}
                                pagelength={confPantalla.tipgf.padre.datatable.pagelength}
                                handleEditReg= { e => handleEditRegPrin(e, confPantalla.tipgf.padre.urls, confPantalla.tipgf.hijo.urls, confPantalla.tipgf.padreshijos, confPantalla.tipgf.hijo.modelform, confPantalla.tipgf.padre.tabla) }
                                handleDeleteItem={ e => handleDeleteItemPrin(e, confPantalla.tipgf.padre.urls, confPantalla.tipgf.padre.modelform, confPantalla.tipgf.padre.tabla, confPantalla.tipgf.title) }
                                saveLoadingTable={ saveLoadingTable }
                                loadingTable={loadingTable}
                                columnactions={confPantalla.tipgf.padre.datatable.columnactions.title}
                                traduction={confPantalla.config.trad.components.datatable}
                            />                                                                                                             
                            </Section>
                        :
                            <LoadingPage />
                        }
                    </Fragment>
                }
                
            </section>
        </div>
        <Footer />        
        </div>

    );

}
export default TipGf